import React from 'react';
var IframeComponent = function (props) {
  const { data, setData } = props.dataControl;
  return (
    <iframe
      id="iframe"
      className={`iframe ${data.device}`}
      src={data.src}
      frameBorder="{0}"
      width="100%"
      sandbox="allow-forms allow-popups allow-pointer-lock allow-same-origin allow-scripts"
    ></iframe>
  );
};
export default IframeComponent;
